<template>
    <b-card :id="componentId" style="width: 100%;">
        <b-row class="my-1">
            <b-col cols="3" style="text-align: left; font-weight: bold;">
                <label>{{ $t('nonconformity') }}:</label>
            </b-col>
            <b-col sm="9" style="text-align: left;">
                {{ pageType==='list'&&auditType==='Action'? ticket.textInput: ticket.scope }}
            </b-col>
        </b-row>
        <b-row class="my-1" v-if="pageType==='list'&&auditType==='Action'">
            <b-col sm="3" style="text-align: left; font-weight: bold;">
                <label>{{ translate('action') }}:</label>
            </b-col>
            <b-col sm="9" style="text-align: left;white-space: pre-line;">{{ticket.scope?ticket.scope:'-'}}</b-col>
        </b-row>
        <b-row class="my-1" v-if="pageType==='detail'||(pageType==='list'&&auditType==='Audit')">
            <b-col sm="3" style="text-align: left; font-weight: bold;">
                <label>{{ $t('nonconformanceType') }}:</label>
            </b-col>
            <b-col sm="9" style="text-align: left;">
                {{ nonconformanceArticleText ? $t(nonconformanceArticleText) : "-" }}
            </b-col>
        </b-row>
        <b-row class="my-1" v-if="pageType==='detail'||(pageType==='list'&&auditType==='Audit')">
            <b-col sm="3" style="text-align: left; font-weight: bold;">
                <label>{{ $t('revisedDocumentInfo') }}:</label>
            </b-col>
            <b-col sm="9" style="text-align: left;">
                {{ ticket.textInput ? ticket.textInput : "-"  }}
            </b-col>
        </b-row>
        <b-row class="my-1" v-if="pageType==='detail'||(pageType==='list'&&auditType==='Audit')">
            <b-col sm="3" style="text-align: left; font-weight: bold;">
                <label>{{ $t('urgentActionText') }}:</label>
            </b-col>
            <b-col sm="9" style="text-align: left;">
                {{ ticket.urgentActionInput ? ticket.urgentActionInput : "-"  }}
            </b-col>
        </b-row>
        <b-row class="my-1" v-if="pageType==='detail'||(pageType==='list'&&auditType==='Audit')">
            <b-col sm="3" style="text-align: left; font-weight: bold;">
                <label>{{ $t('reasonAnalysisText') }}:</label>
            </b-col>
            <b-col sm="9" style="text-align: left;">
                {{ ticket.reasonAnalysisInput ? ticket.reasonAnalysisInput : "-"  }}
            </b-col>
        </b-row>
        <b-row class="my-1" v-if="pageType==='detail'||(pageType==='list'&&auditType==='Audit')">
            <b-col sm="3" style="text-align: left; font-weight: bold;">
                <label>{{ $t('action') }}:</label>
            </b-col>
            <b-col sm="9" style="text-align: left;">
                {{ nonconformanceActionText  ? $t(nonconformanceActionText) : "-"  }}
            </b-col>
        </b-row>
        <b-row class="my-1">
            <b-col sm="3" style="text-align: left; font-weight: bold;">
                <label>{{ $t('note') }}:</label>
            </b-col>
            <b-col sm="9" style="text-align: left;">
                {{ ticket.note ? ticket.note : "-" }}
            </b-col>
        </b-row>
        <b-row class="my-1">
            <b-col sm="3" style="text-align: left; font-weight: bold; align-self: center">
                <label>{{ $t('auditDate') }}:</label>
            </b-col>
            <b-col sm="9" style="text-align: left">
                <el-date-picker
                    v-model="ticket.auditDate"
                    type="date"
                    :readonly="true"
                    format="dd/MM/yyyy"
                    style="width: 100%;"
                    />
            </b-col>
        </b-row>
        <b-row class="my-4" v-if="pageType==='detail'||(pageType==='list'&&auditType==='Audit')">
            <b-col sm="3" style="text-align: left; font-weight: bold;">
                <label>{{ $t('additionalFiles') }}:</label>
            </b-col>
            <b-col sm="9">
                <b-row align-h="start" no-gutters>
                    <b-col cols="1" v-if="ticket.documents.length" v-for="(file, index) in ticket.documents" :key="index" style=" cursor: pointer; align-self: center">
                        <div @click="downloadFile(file.fileUrl)" style="text-align: center"><i class="fas fa-file-alt fa-lg"></i></div>
                        <div style="font-size: 12px; text-align: center">{{file.filename | textToShortText}}</div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row align-h="end" v-if="pageType==='detail'||(pageType==='list'&&auditType==='Audit')">
            <b-col cols="6" style="font-weight: bold; color: #707070; font-size: 1rem; text-align: right">
                <label>{{ $t('lastUpdatedAt') }}: {{ ticket.updatedAt | formatDate('YYYY-MM-DD') }}</label>
            </b-col>
        </b-row>
        <b-row align-h="end" v-if="pageType==='detail'||(pageType==='list'&&auditType==='Audit')">
            <b-col cols="6" style="font-weight: bold; color: #707070; font-size: 1rem; text-align: right">
                <label>{{ $t('extendedDate') }}: {{ firstExtendedDate(ticket, pageType) }}</label>
            </b-col>
        </b-row>
        <b-row align-h="start">
            <b-col>
                <b-button v-show="isAdmin && !ticket.state && isPostsEmpty" @click="showUpdateTicketModal($event.target)" style="float: left">{{ $t('edit') }}</b-button>
                <b-button v-show="isAgent && (ticket.posts)&&(pageType==='detail'||(pageType==='list'&&auditType==='Audit')) && isPostsEmpty" @click="new Date(ticket.expectedDate) < new Date() && $store.state.user.permissions.canStartAudits? showReplyModal($event.target, 'negative'):showReplyModal($event.target)" style="float: right">{{ $t('reply') }}</b-button>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import _ from 'lodash';
import uuid from 'uuid/v4';
import moment from 'moment';
export default {
    props: [
        'ticket',
        'pageType',
        'auditType',
        'selectedSiteId',
        'ticketId',
        'updateFunction',
        'isPostsEmpty'
    ],
    data() {
        return {
            componentId: uuid()
        };
    },
    methods: {
        translate(word){
            /*
            if(this.gbId(this.$store.state.user.customerId)){
                switch(word){
                    case 'action':
                            return this.$t('actionGB');
                    }
            }
            */
            switch(word){
                case 'action':
                        return this.$t('action');
                }
            return "-"
        },
        firstExtendedDate(ticket, pageType) {
            if (pageType === 'list') {
                var extendedDate = moment(ticket.extendedDate).format('YYYY-MM-DD');
                if (extendedDate === 'Invalid date') {
                    return '-';
                }
                return extendedDate;
            }
            let extendedDates = _.map(ticket.posts, 'extendedDate');
            // returns valid date : if there isn't any extended date, returns expected date.
            let selectedDate = extendedDates[Object.keys(extendedDates).length - 1]
                ? moment(extendedDates[Object.keys(extendedDates).length - 1]).format('YYYY-MM-DD')
                : '-';
            return selectedDate;
        },
        showUpdateTicketModal(target) {
            if (this.ticket.ticketType == 'Action') {
                this.$store.commit('SET_MODAL', {
                    eventId: uuid(),
                    type: 'updateTicket',
                    payload: {
                        siteId: this.selectedSiteId,
                        ticket: this.ticket,
                        ticketId: this.ticket.id,
                        ticketType: this.ticket.ticketType
                    }
                });
                this.$nextTick(() => {
                    this.$root.$emit('bv::show::modal', 'createAction', target);
                    this.$eventHub.$once(this.$store.state.modal.eventId, updatedTicket => {
                        for (let key in updatedTicket) {
                            this.ticket[key] = updatedTicket[key];
                        }
                        if (this.updateFunction) {
                            this.updateFunction();
                        }
                    });
                });
            } else {
                this.$store.commit('SET_MODAL', {
                    eventId: uuid(),
                    type: 'updateTicket',
                    payload: {
                        siteId: this.selectedSiteId,
                        ticket: this.ticket,
                        ticketId: this.ticket.id,
                        ticketType: this.ticketType
                    }
                });
                this.$nextTick(() => {
                    this.$root.$emit('bv::show::modal', 'createTicket', target);
                    this.$eventHub.$once(this.$store.state.modal.eventId, updatedTicket => {
                        for (let key in updatedTicket) {
                            this.ticket[key] = updatedTicket[key];
                        }
                        if (this.updateFunction) {
                            this.updateFunction();
                        }
                    });
                });
            }
        },
        showReplyModal(target, replyType) {
            this.$store.commit('SET_MODAL', {
                eventId: uuid(),
                type: 'createPost',
                payload: {
                    siteId: this.selectedSiteId,
                    ticket: this.ticket,
                    ticketId: this.ticketId,
                    replyType: replyType
                }
            });
            this.$nextTick(() => {
                this.$root.$emit('bv::show::modal', 'createPost', target);
                this.$eventHub.$once(this.$store.state.modal.eventId, createdPost => {
                    this.ticket.posts.push(createdPost);
                    this.ticket.isErasable = false;
                });
            });
        }
    },
    computed: {
        nonconformanceArticleText() {
            if (this.ticket.ticketType == 'Audit') {
                return _.get(
                    _.find(this.$store.state.nonconformances, {id: this.ticket.nonconformanceId}),
                    'article'
                );
            }
        },
        nonconformanceActionText() {
            if (this.ticket.ticketType == 'Audit') {
                if (this.ticket.nonconformanceId !== 13) {
                    return _.get(
                        _.find(this.$store.state.nonconformances, {
                            id: this.ticket.nonconformanceId
                        }),
                        'action'
                    );
                } else {
                    return this.ticket.customNonconformance;
                }
            }
        },
        isAdmin() {
            return this.$store.state.user.permissions.canStartAudits;
        },
        isAgent() {
            return this.$store.state.user.permissions.canReplyToAudits;
        }
    }
};
</script>
<style lang="scss" scoped>
</style>

<i18n src="../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "revisedDocumentInfo": "Tamamlanan Döküman Bilgisi",
            "urgentActionText": "Acil Alınacak Aksiyonlar",
            "reasonAnalysisText": "Kök Neden Analizi",
            "additionalFiles": "Ek Dosyalar",
            "action": "Genel Aksiyon Tanımları"
        },
        "en": {
            "revisedDocumentInfo": "Complited Document Information",
            "urgentActionText": "Urgent Actions to be taken",
            "reasonAnalysisText": "Root Cause Analysis",
            "auditDate": "Audit Date",
            "additionalFiles": "Additional Files",
            "action": "Action"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/components/TicketDetailCard.vue